import { camelCase } from '@edicom/common/case/camelCase';
import { FbPopupCellEditorClass } from '../cells/FbPopupCellEditorClass';

// @odeniel se usa para el textarea
export default function popupFieldCellService({ FbCellEditor, TYPES }) {
  return function generate(viewField, engineApi, engineGridApi) {
    const column = engineApi.cell.setCommonAttributes(viewField, engineApi, engineGridApi);
    const type = camelCase(viewField.type);

    // renderer
    column.renderer = type;

    // editor
    const renderPopup = renderPopupFactory();
    const isOpened = true;
    column.editor = FbPopupCellEditorClass(FbCellEditor, {}, { isOpened, renderPopup });

    function renderPopupFactory() {
      const generatorService = TYPES[type]();

      if (engineApi.allowInvalid) {
        viewField.metadata = viewField.metadata ?? {};
        viewField.metadata.allowInvalid = true;
      }

      const template = generatorService(viewField, engineApi)
        .addAttribute('ec-flex', '8') // forzamos que el input se extiende al 100% de la celda
        .addAttribute('ec-autofocus', 'select')
        .toString();

      return () => {
        return template;
      };
    }

    return column;
  };
}
